import './ActiveTablesSorting.styles.scss';

import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import React, { FC } from 'react';

import { ActiveTablesSortProperty } from '../../../model/ActiveTablesSorting';
import { SortDirection } from '../../../model/SortDirection';
import sessionStorageStore from '../../../store/SessionStorageStore';
import tableStore from '../../../store/TableStore';

const ActiveTablesSorting: FC = () => {
  const sortingOrders = [...tableStore.activeTablesSorting.keys()];

  const getSortIcon = (sortProperty: ActiveTablesSortProperty): string =>
    tableStore.activeTablesSorting.get(sortProperty) === SortDirection.ASC
      ? 'pi-sort-amount-up-alt'
      : 'pi-sort-amount-down';

  const onSortingPropertyUpdate = (
    sortProperty: ActiveTablesSortProperty,
  ): void => {
    if (!tableStore.activeTablesSorting.has(sortProperty)) {
      tableStore.setActiveTablesSortProperty(sortProperty, SortDirection.DESC);
    } else if (
      tableStore.activeTablesSorting.get(sortProperty) === SortDirection.DESC
    ) {
      tableStore.setActiveTablesSortProperty(sortProperty, SortDirection.ASC);
    } else {
      tableStore.deleteActiveTablesSortProperty(sortProperty);
    }
    sessionStorageStore.setActiveTablesSorting(tableStore.activeTablesSorting);
  };

  return (
    <>
      {Object.values(ActiveTablesSortProperty).map(sortProperty => {
        const sortingOrder = sortingOrders.indexOf(sortProperty);
        return (
          <Button
            key={`${sortProperty}-sort-property`}
            className={`${sortProperty
              .toLowerCase()
              .replace(' ', '-')} sort-property${
              sortingOrder !== -1 ? ' sort-property-active-' + sortingOrder : ''
            }`}
            icon={`pi ${
              sortingOrder !== -1 ? getSortIcon(sortProperty) : 'pi-sort-alt'
            }`}
            onClick={() => onSortingPropertyUpdate(sortProperty)}
            tooltip={sortProperty}
            text
            rounded
          />
        );
      })}
    </>
  );
};

export default observer(ActiveTablesSorting);
